import { lazy, Suspense } from 'react';

import { cn } from '../../../shared/lib/cn';
import type { ITemplateInputProps } from './template-input-editor';

export type { ITemplateInputProps } from './template-input-editor';

// Split like shared/ui/code-view: CodeMirror arrives with the first step panel that needs it.
const Editor = lazy(() =>
  import('./template-input-editor').then((module) => ({ default: module.TemplateInputEditor })),
);

export const TemplateInput = (props: ITemplateInputProps) => (
  <Suspense
    fallback={
      <div
        aria-busy
        className={cn(
          'min-h-template-field rounded-control border border-border-raised bg-field px-input py-2',
          'font-mono text-data whitespace-pre-wrap text-primary',
          props.className,
        )}
      >
        {props.value}
      </div>
    }
  >
    <Editor {...props} />
  </Suspense>
);
